/**
 * Control layers to show on the map.
 * @author: adalto.junior
 * Date: 06/12/13
 * Time: 09:47
 */


Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};

Greenmile.Toolbar.Map.LayerControl = function (selector, map, options) {

    const storage = new Greenmile.Storage.StoreMapPosition();
    this.checks = storage.getLayerMapFromUser();

    if (this.checks === null) {
        this.checks = storage.setLayerMapFromUser();
    }

    const layerRadiusAction = new Greenmile.Toolbar.MapLayerActions.LayerRadius();
    const stopsAction = new Greenmile.Toolbar.MapLayerActions.Stops();
    const layerExpandedRadiusStop = new Greenmile.Toolbar.MapLayerActions.LayerExpandedRadius();

    stopsAction.setEvent("afterClickOnCheckBox", ()  => {

        if (!stopsAction.checkBox.checked) {

            if(layerRadiusAction.checkBox.checked) {
                layerRadiusAction.checkBox.click();
            }
            if(layerExpandedRadiusStop.checkBox.checked){
                layerExpandedRadiusStop.checkBox.click();
            }
        }

    });

    const routeLayers = {
      layerActualRouteWithMultiRoute: {
          enabled: false,
          action: new Greenmile.Toolbar.MapLayerActions.LayerActualRouteWithMultiRoute(options.routeId)
      },
      layerActualRoute: {
          enabled: false,
          action: new Greenmile.Toolbar.MapLayerActions.LayerActualRoute()
      },
      layerPlannedRoute: {
          enabled: false,
          action: new Greenmile.Toolbar.MapLayerActions.LayerPlannedRoute()
      },
      layerBaselinePlannedRoute: {
          enabled: false,
          action: new Greenmile.Toolbar.MapLayerActions.LayerBaselinePlannedRoute()
      }
    };

    const stopLayers = {
      layerStops: {
          enabled: false,
          action: stopsAction
      },
      layerRadiusRoute: {
          enabled: false,
          action: layerRadiusAction
      },
      layerExpandedRadiusStop: {
          enabled: false,
          action: layerExpandedRadiusStop
      },
      layerEventRoute: {
          enabled: false,
          action: new Greenmile.Toolbar.MapLayerActions.LayerEvent('event_route', options.routeId)
      },
      layerEventEquipment: {
          enabled: false,
          action: new Greenmile.Toolbar.MapLayerActions.LayerEvent('event_equipment')
      },
      layerPendingOrders: {
          enabled: false,
          action: new Greenmile.Toolbar.MapLayerActions.PendingOrders()
      },
      layerSignatures: {
          enabled: false,
          action: new Greenmile.Toolbar.MapLayerActions.Signatures()
      },
      layerArrival: {
          enabled: false,
          action: new Greenmile.Toolbar.MapLayerActions.Arrival()
      },
      layerDeparture: {
        enabled: false,
        action: new Greenmile.Toolbar.MapLayerActions.Departure()
      }
    };

    const allLayers = {
      ...routeLayers,
      ...stopLayers
    }

    const renderLayerItems = (layers) => {
      const fragment = document.createDocumentFragment();
      for (const layerKey in layers) {
        const layer = layers[layerKey];
        if (layer.enabled) {
          const action = layer.action;
          action.setRouteId(options.routeId);

          if (action) {
            action.map = map;

            if (layer.instanceDataClass) {
              action.setInstanceToClassData(layer.instanceDataClass);
            }

            fragment.appendChild(action.render());
          }
        }
      }
      return fragment;
    };

    /**
     * Habilita as camadas
     * @param layers Array
     */

    this.enableLayers = (layers) => {
      layers.forEach((item) => {
        const layer = allLayers[item.layer];
        if (layer) {
          layer.enabled = true;
          if (item.instanceDataClass) {
            layer.instanceDataClass = item.instanceDataClass;
          }
        }
      });

    };

    this.renderLayersEnabled = () => {

      const parentElement = document.querySelector(selector + ' .dropdownLayer.mapLayer li ul');
      const elementRouteLayers = renderLayerItems(routeLayers);
      const elementStopLayers = renderLayerItems(stopLayers);

      if (parentElement && elementRouteLayers) {
        if (elementRouteLayers.childElementCount) {
          parentElement.appendChild(elementRouteLayers);
          const sectionSeparator = document.createElement('li');
          sectionSeparator.className = 'sectionSeparator';
          parentElement.appendChild(sectionSeparator);
        }
        if (elementStopLayers.childElementCount) {
          parentElement.appendChild(elementStopLayers);
        }
      }

    };

    this.addListeners = () => {

        this.enableLayers(options.layersToEnable);
        this.renderLayersEnabled();

    };

};
